(function () {
  const breadcrumb = document.getElementsByClassName("breadcrumb")[0];
  if (!breadcrumb) {
    return;
  }

  const links = breadcrumb.getElementsByTagName("a");
  const spans = breadcrumb.getElementsByTagName("span");
  const current = spans[spans.length - 1];
  if (!current) {
    return;
  }

  let payload = {
    "@context": "https://schema.org/",
    "@type": "BreadcrumbList",
    itemListElement: [],
  };

  // Build the JSON-LD payload
  for (let i = 0; i < links.length; i++) {
    payload.itemListElement.push({
      "@type": "ListItem",
      position: i + 1,
      name: links[i].innerText,
      item: links[i].href,
    });
  }

  const orchidToysUrl = 'https://orchidtoys.com';

  payload.itemListElement.push({
    "@type": "ListItem",
    position: links.length + 1,
    name: current.innerText,
    item: orchidToysUrl + window.location.pathname,
  });

  // Inject dynamic BreadcrumbList JSON-LD
  let el = document.createElement("script");
  el.type = "application/ld+json";
  el.text = JSON.stringify(payload);
  document.querySelector("head")?.appendChild(el);
})();
